import * as serviceContext from "../services/serviceContext";

var options = {};
var headers = new Headers();

headers.append("Content-Type", "application/json");
options.headers = headers;

export async function getUsers() {
  try {
    const response = await serviceContext.get("/viewUser", null, options);
    const res = response.json();
    return res;
  } catch (error) {
    return error;
  }
}

export async function getProfileData() {
  try {
    const response = await serviceContext.get("/getProfile", null, options);
    const res = response.json();
    return res;
  } catch (error) {
    return error;
  }
}
